import React, {useEffect, useState} from 'react';
import {Portal, Snackbar} from "@mui/material";
import {observer} from "mobx-react";
import {Alert} from "@mui/lab";
import {notifier} from "../lib/Notifier";

const Notification: React.FC = () => {

    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {

        if (notifier.notifications.length >= 1 && !open) {
            setOpen(true);
        }
        if (notifier.notifications.length === 0) {
            setOpen(false);
        }

    }, [notifier.notifications.length]);

    const handleCloseSnackbar = (event: React.SyntheticEvent, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }

        setOpen(false);
    };

    const notification = notifier.notifications[0];
    const autoHideDuration = ["error", "warning"].includes(notification?.severity) ? null : 6000;

    return <Portal> <Snackbar
            autoHideDuration={autoHideDuration}
            sx={
                {
                    // marginBottom: "100px"
                }
            }
            anchorOrigin={
                {
                    vertical: "bottom",
                    horizontal:
                            "center"
                }
            }
            open={open}
            onClose={handleCloseSnackbar}
            TransitionProps={
                {
                    onExited: () => {
                        notifier.notifications.shift();
                        if (notifier.notifications.length > 0) {
                            setOpen(true);
                        }
                    }
                }
            }
    >
        {notification && <Alert
                onClose={handleCloseSnackbar}
                variant={notification.variant}
                severity={notification.severity}
        >
            {notification.message}
        </Alert>}
    </Snackbar>
    </Portal>
}

export default observer(Notification);
